module.exports = __webpack_public_path__ + "static/media/batman.16660d97.png";